import React from 'react';
import { useSelector } from 'react-redux';

import { buildSelectedAssetList } from 'selectors/Assets';
import { capFirst } from 'utils/common';
import { TYPES } from 'utils/constants';

import './SelectCount.css';

export default function SelectCount({ type, label }) {
	const selectedIds = useSelector(state => new Set(state.selected[type]));
	const items = useSelector((state) => {
		if(type === TYPES.ASSETS) {
			return buildSelectedAssetList(state);
		}
		if(type === TYPES.VERSIONS){
			return state.creativeVersions.items;
		}
		return state[type].items;
	});

	if(selectedIds.size === 0) {
		return null;
	}

	let { length } = items;
	let selectType = label ? label : type;

	return (
		<span className="select-count">
			{`${selectedIds.size} of ${length} ${capFirst(selectType, selectedIds.size)}:`}
		</span>
	);
}

SelectCount.displayName = 'SelectCount';
SelectCount.defaultProps = {
	type:"",
	label:null,
};
